import React from "react";

const StatusResolve = () => {
  return (
    <div className="resolu">
      <span>
        <i className="fas fa-check fa-beat"></i> Résolu !
      </span>
    </div>
  );
};

export default StatusResolve;
